import {ICrudStore} from 'Store'
import {action} from 'mobx'
import {api} from 'helpers/Api'
import {ReceiptLayout} from './Model'

export default class implements ICrudStore<ReceiptLayout> {
  data: ReceiptLayout[] = []
  loaded: boolean = false

  read(id?: number) {
    console.log('ReceiptLayouts/Store - read')
    if (id) return api.get('receiptlayouts' + id)
    return api.get('receiptlayouts').then((value) => {
      // console.log('receiptLayouts', value)
      this.set(value)
      return value
    })
  }

  create(value: ReceiptLayout) {
    return api.post('receiptlayouts', value).then(this.push)
  }

  update(id: number, value: ReceiptLayout) {
    return api.put('receiptlayouts/' + id, value).then(this.replace)
  }

  @action
  private set = (values: ReceiptLayout[]) => {
    this.data = values.map((item: ReceiptLayout) => new ReceiptLayout(item))
    this.loaded = true
  };

  @action
  private push = (value: ReceiptLayout) => {
    this.data.push(new ReceiptLayout(value))
  }

  @action
  private replace = (value: ReceiptLayout) => {
    this.data.splice(this.data.findIndex(f => f.id === value.id), 1, value)
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/ReceiptLayouts/Store.ts